function formatDateTime(value) {
  if (!value) return 'Não informado'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return date.toLocaleString('pt-BR')
}

export default function DeadlineAuditTechnicalPanel({ audit, rawResult }) {
  const technicalNotes = audit?.technicalNotes || []
  const appliedRules = audit?.appliedRules || []

  return (
    <section className="rules-card deadline-result-section deadline-audit-panel">
      <details>
        <summary>
          <span>
            <strong>Painel técnico de auditoria</strong>
            <small>Hashes, regras aplicadas, notas técnicas e JSON bruto para depuração.</small>
          </span>
          <i className="fas fa-chevron-down" />
        </summary>

        <div className="rules-card-body deadline-audit-body">
          <dl className="deadline-audit-grid">
            <div>
              <dt>Hash de entrada</dt>
              <dd>{audit?.inputHash || 'Não informado'}</dd>
            </div>
            <div>
              <dt>Hash de saída</dt>
              <dd>{audit?.outputHash || 'Não informado'}</dd>
            </div>
            <div>
              <dt>Versão das regras</dt>
              <dd>{audit?.ruleSetVersion || 'Não informada'}</dd>
            </div>
            <div>
              <dt>Início</dt>
              <dd>{formatDateTime(audit?.startedAt)}</dd>
            </div>
            <div>
              <dt>Fim</dt>
              <dd>{formatDateTime(audit?.finishedAt)}</dd>
            </div>
          </dl>

          <div className="deadline-audit-columns">
            <div>
              <h4>Regras aplicadas</h4>
              {appliedRules.length ? (
                <ul className="deadline-result-list">
                  {appliedRules.map((rule, index) => <li key={`${rule}-${index}`}>{rule}</li>)}
                </ul>
              ) : <p>Nenhuma regra aplicada informada.</p>}
            </div>
            <div>
              <h4>Notas técnicas</h4>
              {technicalNotes.length ? (
                <ul className="deadline-result-list">
                  {technicalNotes.map((note, index) => <li key={`${note}-${index}`}>{note}</li>)}
                </ul>
              ) : <p>Nenhuma nota técnica informada.</p>}
            </div>
          </div>

          <details className="deadline-raw-json">
            <summary>JSON bruto da resposta</summary>
            <pre>{JSON.stringify(rawResult, null, 2)}</pre>
          </details>
        </div>
      </details>
    </section>
  )
}
